import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reduxForm, Field, stopSubmit, startSubmit} from 'redux-form'
import Splash from './Splash'
import {actions as authActions} from '../../redux/modules/Auth'

const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(authActions, dispatch),
    formError: (error) => {
      dispatch(stopSubmit('login', {_error: error}))
    },
    login: (data) => {
      dispatch(startSubmit('login'))
      return dispatch(authActions.doLogin(data))
    }
  }
}

class SplashContainer extends Component {
  static propTypes = {
    history: PropTypes.object,
    actions: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.onRegisterClick = this.onRegisterClick.bind(this)
    this.onPasswordForgot = this.onPasswordForgot.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onPasswordForgot () {
    this.props.history.push('/forgot-password')
  }

  onRegisterClick () {
    this.props.history.push('/register')
  }

  onSubmit (credentials) {
    this.props.actions.loginRequest(credentials)
    /* this.props.login(credentials).then(() => {
        if(this.props.state.token) {
            this.props.history.push("/projects");
        }
    }); */
  }

  render () {
    return (
      <Splash
        onRegisterClick={this.onRegisterClick}
        onPasswordForgot={this.onPasswordForgot}
        onSubmit={this.onSubmit} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SplashContainer)



// WEBPACK FOOTER //
// ./src/containers/Splash/SplashContainer.js